module.exports = __webpack_public_path__ + "img/351594b.png";